import React, { useState } from "react";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  useGeneratedHtmlId,
  EuiButtonIcon,
  EuiSpacer,
  EuiBadge,
  EuiFlexGroup,
  EuiFlexItem,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";

const TeamsUserEdit = ({ props, closeModalProp, organizationId }) => {
  const [response, setResponse] = useState("");

  const [ddi, setDdi] = useState(getLineNumber(props.LineUri));
  const [extension, setExtension] = useState(getExtension(props.LineUri));

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [responseColor, setResponseColor] = useState("success");

  const modalFormId = useGeneratedHtmlId({ prefix: "modalForm" });

  const closeModal = () => {
    setIsModalVisible(false);
    closeModalProp();
  };
  const showModal = () => setIsModalVisible(true);

  const applyConfig = async (event) => {
    event.preventDefault();
    setLoading(true);
    const token = sessionStorage.getItem("krakenT");
    const data = {
      userIdentity: props.UserIdentity,
      email: props.UserPrincipalName,
      name: props.DisplayName,
      organizationId,
      ddi,
      extension,
    };

    OrganizationService.applyUserConfig({ token, data })
      .then((response) => {
        const message =
          response.data.status === "success"
            ? "Config applied succesfully"
            : "Unexpected response format";
        setResponseColor("success");
        setLoading(false);
        setResponse(message);
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Some error occurred";

        setResponseColor("danger");
        setLoading(false);
        setResponse(errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function getLineNumber(lineUri) {
    if (!lineUri || typeof lineUri !== "string") {
      return "";
    }

    const regex = /tel:(\+\d+)/;
    const match = lineUri.match(regex);

    if (match) {
      return match[1];
    }

    return "";
  }

  function getExtension(lineUri) {
    if (!lineUri || typeof lineUri !== "string") {
      return "";
    }

    const regex = /tel:\+\d+(?:;ext=(\d+))?/;
    const match = lineUri.match(regex);

    if (match && match[1]) {
      return match[1];
    }

    return "";
  }

  const formSample = (
    <EuiForm id={modalFormId} component="form" onSubmit={applyConfig}>
      <EuiFormRow label="Name">
        <EuiFieldText disabled value={props.DisplayName} />
      </EuiFormRow>
      <EuiFormRow label="UPN">
        <EuiFieldText disabled value={props.UserPrincipalName} />
      </EuiFormRow>
      <EuiSpacer></EuiSpacer>
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFormRow label="Numbering (E164 with + format)">
            <EuiFieldText
              value={ddi}
              onChange={(e) => setDdi(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Extension">
            <EuiFieldText
              value={extension}
              onChange={(e) => setExtension(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiForm>
  );

  let modal;

  if (isModalVisible) {
    modal = (
      <EuiModal onClose={closeModal} initialFocus="[name=popswitch]">
        <EuiModalHeader>
          <EuiModalHeaderTitle>Editing User</EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          <EuiSpacer size="m" />
          {formSample}
          <EuiSpacer size="m" />
          {response !== "" && (
            <EuiBadge color={responseColor}>{response}</EuiBadge>
          )}
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Cancel</EuiButtonEmpty>

          <EuiButton type="submit" form={modalFormId} fill isLoading={loading}>
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  }

  return (
    <div>
      <EuiButtonIcon
        color="success"
        size="xs"
        display="base"
        iconType="documentEdit"
        aria-label="Next"
        onClick={showModal}
      ></EuiButtonIcon>
      {modal}
    </div>
  );
};

export default TeamsUserEdit;
